define.alias("ember-math-helpers/helpers/fround", "settings/helpers/fround");